export default function authHeader() {
  return {
    "Content-Type": "application/json",
    Url: window.location.href,
    "X-Frame-Options": "SAMEORIGIN",
  };
}
